import React from 'react';

import { TStepProps } from './interfaces';

const Step: React.FC<TStepProps> = ({ children }) => <>{children}</>;

export default Step;